/* Holy Cow Cinematic - global bootstrap (Phase 1 Foundation) */
(function () {
  'use strict';

  var prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var inEditor = window.Shopify && window.Shopify.designMode;

  var lenis = null;
  var scrollProgressBound = false;
  var navDrawerBound = false;

  /* ---------- Section-init registry (theme-editor safe) ---------- */
  var HC = window.HC = window.HC || { inits: {}, teardowns: {} };
  HC.register = function (type, initFn) { HC.inits[type] = initFn; };
  HC.initSection = function (root) {
    if (!root) return;
    var type = root.getAttribute('data-hc-section');
    if (!type || !HC.inits[type]) return;
    HC.teardownSection(root);
    try { HC.teardowns[root.id] = HC.inits[type](root) || null; }
    catch (e) { if (window.console) console.warn('[HC] init failed for ' + type, e); }
  };
  HC.teardownSection = function (root) {
    if (!root) return;
    var t = HC.teardowns[root.id];
    if (typeof t === 'function') { try { t(); } catch (e) {} }
    delete HC.teardowns[root.id];
  };
  HC.initAll = function () {
    var nodes = document.querySelectorAll('[data-hc-section]');
    for (var i = 0; i < nodes.length; i++) HC.initSection(nodes[i]);
  };

  /* ---------- Cart helpers (Shopify AJAX API) ---------- */
  HC.cart = {
    add: function (variantId, quantity) {
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: quantity || 1 })
      }).then(function (r) {
        if (!r.ok) { return r.json().then(function (err) { throw err; }); }
        return r.json();
      }).then(function (line) {
        HC.cart.refreshCount();
        document.dispatchEvent(new CustomEvent('hc:cart:added', { detail: line }));
        return line;
      });
    },
    change: function (lineKey, quantity) {
      return fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: lineKey, quantity: quantity })
      }).then(function (r) {
        if (!r.ok) { return r.json().then(function (err) { throw err; }); }
        return r.json();
      }).then(function (cart) { HC.cart.refreshCount(); return cart; });
    },
    get: function () { return fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }); },
    refreshCount: function () {
      return HC.cart.get().then(function (cart) {
        /* :not(html) is load-bearing: refreshCount also stamps data-cart-count on
           <html> below, so a bare [data-cart-count] would match the documentElement
           on every call after the first and wipe the whole page via textContent. */
        var els = document.querySelectorAll('[data-cart-count]:not(html)');
        for (var i = 0; i < els.length; i++) els[i].textContent = cart.item_count;
        var links = document.querySelectorAll('[data-cart-link]');
        for (var j = 0; j < links.length; j++) links[j].hidden = !(cart.item_count > 0);
        document.documentElement.setAttribute('data-cart-count', cart.item_count);
        return cart.item_count;
      });
    }
  };

  /* ---------- Custom cursor ---------- */
  function initCursor() {
    var cursor = document.getElementById('cursor');
    var ring = document.getElementById('cursor-ring');
    if (!cursor || !ring || window.matchMedia('(pointer: coarse)').matches) return;
    var mx = 0, my = 0, rx = 0, ry = 0;
    document.addEventListener('mousemove', function (e) {
      mx = e.clientX; my = e.clientY;
      cursor.style.transform = 'translate(' + mx + 'px,' + my + 'px) translate(-50%,-50%)';
    });
    (function ringLoop() {
      rx += (mx - rx) * 0.18; ry += (my - ry) * 0.18;
      ring.style.transform = 'translate(' + rx + 'px,' + ry + 'px) translate(-50%,-50%)';
      requestAnimationFrame(ringLoop);
    })();
    document.querySelectorAll('[data-cursor="hover"], a, button').forEach(function (el) {
      el.addEventListener('mouseenter', function () { cursor.classList.add('hover'); });
      el.addEventListener('mouseleave', function () { cursor.classList.remove('hover'); });
    });
  }

  /* ---------- Magnetic buttons ---------- */
  function initMagnetic() {
    if (prefersReduced || typeof gsap === 'undefined') return;
    document.querySelectorAll('.magnetic').forEach(function (el) {
      el.addEventListener('mousemove', function (e) {
        var r = el.getBoundingClientRect();
        gsap.to(el, { x: (e.clientX - r.left - r.width / 2) * 0.3, y: (e.clientY - r.top - r.height / 2) * 0.3, duration: 0.4, ease: 'power3.out' });
      });
      el.addEventListener('mouseleave', function () { gsap.to(el, { x: 0, y: 0, duration: 0.5, ease: 'elastic.out(1,0.4)' }); });
    });
  }

  /* ---------- Marquee velocity ---------- */
  function initMarquee() {
    var marquee = document.querySelector('.marquee-track');
    if (!marquee) return;
    var vel = 0;
    if (lenis) lenis.on('scroll', function (e) { vel = e.velocity || 0; });
    (function loop() {
      if (Math.abs(vel) > 0.5) marquee.style.animationDuration = (50 / (1 + Math.abs(vel) * 0.3)) + 's';
      else marquee.style.animationDuration = '50s';
      requestAnimationFrame(loop);
    })();
  }

  /* ---------- Sticky mobile CTA ---------- */
  function initStickyCta() {
    var cta = document.getElementById('sticky-cta');
    var hero = document.getElementById('hero');
    var buy = document.getElementById('buy');
    if (!cta || !hero) return;
    function update() {
      var past = (window.scrollY || window.pageYOffset) > hero.offsetHeight * 0.8;
      var inBuy = buy ? buy.getBoundingClientRect().top < window.innerHeight && buy.getBoundingClientRect().bottom > 0 : false;
      cta.classList.toggle('is-shown', past && !inBuy);
    }
    window.addEventListener('scroll', update, { passive: true });
    update();
  }

  /* ---------- Chapter pill ---------- */
  function initChapterPill() {
    var pill = document.getElementById('chapter-pill');
    if (!pill || !('IntersectionObserver' in window)) return;
    var map = {
      'what-we-are': 'What we are', 'what-it-does': 'What it does', 'how-we-do-it': 'How we do it',
      'built-for': 'Built for', 'how-to-use': 'How to use', 'product': 'The product',
      'reviews': 'Reviews', 'faq': 'FAQ', 'buy': 'Buy'
    };
    var active = {};
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) active[en.target.id] = true; else delete active[en.target.id];
      });
      var ids = Object.keys(active);
      if (ids.length) { pill.textContent = map[ids[ids.length - 1]]; pill.classList.add('is-shown'); }
      else pill.classList.remove('is-shown');
    }, { rootMargin: '-45% 0px -45% 0px' });
    Object.keys(map).forEach(function (id) { var el = document.getElementById(id); if (el) io.observe(el); });
  }

  /* ---------- Nav dark/light over dark sections ---------- */
  function initNavTheme() {
    var nav = document.getElementById('topnav');
    if (!nav || typeof ScrollTrigger === 'undefined') return;
    var dark = document.querySelectorAll('.dark-vignette, footer, #anatomy, #reveal-sect, #marquee-sect, .farm-story, .seework-section, .story-section, .impact-section');
    ScrollTrigger.batch(dark, {
      onEnter: function () { nav.classList.add('nav-dark'); },
      onEnterBack: function () { nav.classList.add('nav-dark'); },
      onLeave: function () { nav.classList.remove('nav-dark'); },
      onLeaveBack: function () { nav.classList.remove('nav-dark'); },
      start: 'top 60px', end: 'bottom 60px'
    });
  }

  /* ---------- Reviews seamless loop ---------- */
  function initReviewsLoop() {
    var track = document.getElementById('reviews-track');
    if (!track || prefersReduced || track.dataset.cloned) return;
    track.dataset.cloned = '1';
    Array.prototype.slice.call(track.children).forEach(function (c) { track.appendChild(c.cloneNode(true)); });
  }

  /* ---------- Preloader + hero intro ---------- */
  /* .char/.word spans are CSS-hidden (cinematic.css) and only become visible via
     the intro timeline (V2 index.html 3002-3008). When the timeline can't run
     (theme editor, no gsap, fallback), force-reveal them so text never stays hidden. */
  function revealIntroText() {
    var els = document.querySelectorAll('.char, .word');
    for (var i = 0; i < els.length; i++) { els[i].style.opacity = '1'; els[i].style.transform = 'none'; }
  }

  function initPreloader() {
    var pre = document.getElementById('preloader');
    if (!pre) { revealIntroText(); return; }
    if (prefersReduced || typeof gsap === 'undefined') { pre.style.display = 'none'; revealIntroText(); return; }
    if (window.__lenis) window.__lenis.stop();
    var pct = { v: 0 };
    var tl = gsap.timeline({ onComplete: function () { if (window.__lenis) window.__lenis.start(); } });
    tl.to(pct, { v: 100, duration: 0.62, ease: 'power2.out', onUpdate: function () { var el = document.getElementById('preload-pct'); if (el) el.textContent = Math.round(pct.v); } })
      .to('.preload-bar', { width: '100%', duration: 0.62, ease: 'power2.out' }, 0)
      .to('.preload-letter', { y: 0, opacity: 1, duration: 0.48, stagger: 0.03, ease: 'expo.out' }, 0.14)
      .to('.preload-letter', { opacity: 0, y: '-0.3em', duration: 0.34, stagger: 0.02, ease: 'expo.in' }, '+=0.05')
      .to('#preloader', { yPercent: -100, duration: 0.62, ease: 'expo.inOut' }, '-=0.08');
    if (document.querySelector('.char, .word')) {
      tl.from('#hero-eyebrow', { opacity: 0, y: 24, duration: 0.9, ease: 'power3.out' }, '-=0.6')
        .to('.char', { y: 0, opacity: 1, duration: 1.0, stagger: 0.04, ease: 'expo.out' }, '-=0.7')
        .to('.word', { y: 0, opacity: 1, duration: 0.8, stagger: 0.025, ease: 'expo.out' }, '-=0.5')
        .from('#hero-tagline', { opacity: 0, y: 20, duration: 0.8, ease: 'power3.out' }, '-=0.55')
        .from('#hero-cta', { opacity: 0, y: 28, duration: 0.8, ease: 'power3.out' }, '-=0.65')
        .from('#hero-trust .hero-chip', { opacity: 0, y: 16, duration: 0.6, stagger: 0.06, ease: 'power3.out' }, '-=0.5')
        .from('#hero-bag-img', { y: 24, scale: 0.97, duration: 0.95, ease: 'expo.out' }, '-=0.85');
    }
    setTimeout(function () {
      if (pre && pre.parentNode) pre.style.transform = 'translateY(-100%)';
      if (window.__lenis) window.__lenis.start();
      revealIntroText();
    }, 3500);
  }

  /* ---------- Reveal-up (shared, scoped, idempotent) ---------- */
  function initRevealUp(root) {
    if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') return;
    var els = (root || document).querySelectorAll('.reveal-up');
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      if (el.dataset.revealed) continue;
      el.dataset.revealed = '1';
      if (el.closest('#buy')) { gsap.set(el, { opacity: 1, y: 0, clearProps: 'transform' }); continue; }
      if (prefersReduced) { gsap.set(el, { opacity: 1, y: 0 }); continue; }
      gsap.from(el, { opacity: 0, y: 40, duration: 1.1, ease: 'expo.out', scrollTrigger: { trigger: el, start: 'top 85%' } });
    }
  }

  /* ---------- Counters (shared) - any [data-count], optional data-suffix ---------- */
  function initCounters(root) {
    if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') return;
    var els = (root || document).querySelectorAll('[data-count]');
    for (var i = 0; i < els.length; i++) {
      (function (el) {
        if (el.dataset.counted) return; el.dataset.counted = '1';
        var target = parseFloat(el.dataset.count);
        var suffix = el.dataset.suffix || '';
        var decimals = (el.dataset.count.indexOf('.') >= 0) ? 1 : 0;
        ScrollTrigger.create({ trigger: el, start: 'top 80%', once: true, onEnter: function () {
          if (prefersReduced) { el.textContent = target.toFixed(decimals) + suffix; return; }
          var obj = { n: 0 };
          gsap.to(obj, { n: target, duration: 1.8, ease: 'power3.out', onUpdate: function () { el.textContent = obj.n.toFixed(decimals) + suffix; } });
        }});
      })(els[i]);
    }
  }

  /* ---------- FAQ accordion (delegated; bind once) ----------
     V2 semantics (index.html 3762-3773): CSS expands on .faq-item.open;
     exclusive - opening one closes the rest. */
  function initFaq() {
    if (initFaq._bound) return; initFaq._bound = true;
    document.addEventListener('click', function (e) {
      var q = e.target.closest ? e.target.closest('.faq-q') : null;
      if (!q) return;
      var item = q.closest('.faq-item') || q.parentElement;
      if (!item) return;
      var open = item.classList.contains('open');
      document.querySelectorAll('.faq-item').forEach(function (i) { i.classList.remove('open'); });
      document.querySelectorAll('.faq-q').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
      if (!open) {
        item.classList.add('open');
        q.setAttribute('aria-expanded', 'true');
      }
    });
  }

  /* ---------- Lenis smooth scroll + GSAP bridge ---------- */
  function initMotion() {
    if (prefersReduced || lenis) return;
    if (typeof Lenis === 'undefined' || typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') return;

    gsap.registerPlugin(ScrollTrigger);

    lenis = new Lenis({ duration: 1.2, easing: function (t) { return Math.min(1, 1.001 - Math.pow(2, -10 * t)); }, smoothWheel: true, smoothTouch: false });
    lenis.on('scroll', ScrollTrigger.update);
    gsap.ticker.add(function (time) { lenis.raf(time * 1000); });
    gsap.ticker.lagSmoothing(0);
    window.__lenis = lenis;
  }

  /* ---------- Cart drawer (mini cart) ----------
     Shell markup lives in snippets/cart-drawer.liquid (layout-rendered, all
     pages). Rows render client-side from /cart.js JSON. Opens on the
     hc:cart:added event (fired by HC.cart.add) and on nav cart-link clicks;
     both are document-delegated because the header section can be reloaded
     by the theme editor. If the shell is missing, nothing binds and every
     add-to-cart path falls back to its native behavior. */
  function initCartDrawer() {
    if (initCartDrawer._bound) return;
    var drawer = document.getElementById('cart-drawer');
    if (!drawer) return;
    initCartDrawer._bound = true;

    var itemsEl = document.getElementById('cart-drawer-items');
    var emptyEl = document.getElementById('cart-drawer-empty');
    var shipEl = document.getElementById('cart-drawer-ship');
    var shipCopy = document.getElementById('cart-drawer-ship-copy');
    var shipFill = document.getElementById('cart-drawer-ship-fill');
    var subEl = document.getElementById('cart-drawer-subtotal');
    var footEl = drawer.querySelector('.cart-drawer-foot');
    var errEl = document.getElementById('cart-drawer-error');
    var closeBtn = document.getElementById('cart-drawer-close');
    var thresholdCents = (parseFloat(drawer.dataset.freeShipThreshold) || 50) * 100;
    var renderSeq = 0;
    var changing = false; /* one /cart/change.js at a time: concurrent changes are applied to the same server snapshot and lose updates */

    function fmt(cents) { return '$' + (cents / 100).toFixed(2); }

    function render(cart) {
      itemsEl.innerHTML = '';
      cart.items.forEach(function (item) {
        var li = document.createElement('li');
        li.className = 'cart-drawer-line';
        li.setAttribute('data-key', item.key);
        li.innerHTML =
          '<div class="cart-drawer-img"></div>' +
          '<div class="cart-drawer-line-main">' +
            '<p class="cart-drawer-line-title"></p>' +
            '<p class="cart-drawer-line-variant"></p>' +
            '<div class="cart-qty">' +
              '<button type="button" data-step="-1" aria-label="Decrease quantity">&minus;</button>' +
              '<span class="cart-drawer-qty-n"></span>' +
              '<button type="button" data-step="1" aria-label="Increase quantity">+</button>' +
            '</div>' +
          '</div>' +
          '<div class="cart-drawer-line-side">' +
            '<p class="cart-drawer-line-price"></p>' +
            '<button type="button" class="cart-drawer-remove" data-remove>Remove</button>' +
          '</div>';
        if (item.image) {
          var im = document.createElement('img');
          im.src = item.image + (item.image.indexOf('?') > -1 ? '&' : '?') + 'width=160';
          im.alt = '';
          im.width = 64; im.height = 64;
          im.loading = 'lazy';
          li.querySelector('.cart-drawer-img').appendChild(im);
        }
        li.querySelector('.cart-drawer-line-title').textContent = item.product_title;
        li.querySelector('.cart-drawer-line-variant').textContent =
          (item.variant_title && item.variant_title !== 'Default Title') ? item.variant_title : '';
        li.querySelector('.cart-drawer-qty-n').textContent = item.quantity;
        li.querySelector('.cart-drawer-line-price').textContent = fmt(item.final_line_price);
        itemsEl.appendChild(li);
      });

      var has = cart.item_count > 0;
      itemsEl.hidden = !has;
      emptyEl.hidden = has;
      shipEl.hidden = !has;
      footEl.hidden = !has;
      /* items_subtotal_price, not total_price: once a checkout session
         exists, change.js responses fold its shipping estimate into
         total_price (observed live: +$19.90 after a Shop Pay visit).
         The subtotal row and free-ship threshold are merchandise-only. */
      var merch = cart.items_subtotal_price != null ? cart.items_subtotal_price : cart.total_price;
      subEl.textContent = fmt(merch);

      var remaining = thresholdCents - merch;
      shipCopy.innerHTML = '';
      if (remaining > 0) {
        shipCopy.appendChild(document.createTextNode(shipCopy.dataset.awayPre + ' '));
        var strong = document.createElement('strong');
        strong.textContent = fmt(remaining);
        shipCopy.appendChild(strong);
        shipCopy.appendChild(document.createTextNode(' ' + shipCopy.dataset.awayPost));
      } else {
        var s2 = document.createElement('strong');
        s2.textContent = shipCopy.dataset.unlocked;
        shipCopy.appendChild(s2);
      }
      shipFill.style.width = Math.min(100, merch * 100 / thresholdCents) + '%';
      errEl.hidden = true;
    }

    function open() {
      var seq = ++renderSeq;
      HC.cart.get().then(function (cart) {
        if (seq !== renderSeq) return; /* a newer request superseded this one */
        render(cart);
        drawer.classList.add('is-open');
        drawer.removeAttribute('inert');
        drawer.setAttribute('aria-hidden', 'false');
        if (closeBtn) closeBtn.focus();
      });
    }

    function shut() {
      drawer.classList.remove('is-open');
      drawer.setAttribute('inert', '');
      drawer.setAttribute('aria-hidden', 'true');
    }

    if (closeBtn) closeBtn.addEventListener('click', shut);
    drawer.addEventListener('click', function (e) {
      if (e.target === drawer) shut();                      /* overlay click */
      if (e.target.closest && e.target.closest('#cart-drawer-shop')) shut(); /* let the anchor scroll behind */
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') shut();
    });

    document.addEventListener('hc:cart:added', open);

    /* Nav cart links open the drawer instead of navigating (plain clicks only) */
    document.addEventListener('click', function (e) {
      if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
      var link = e.target.closest ? e.target.closest('[data-cart-link]') : null;
      if (!link) return;
      e.preventDefault();
      open();
    });

    /* Stepper / remove inside the drawer */
    itemsEl.addEventListener('click', function (e) {
      var stepBtn = e.target.closest ? e.target.closest('[data-step]') : null;
      var removeBtn = e.target.closest ? e.target.closest('[data-remove]') : null;
      if (!stepBtn && !removeBtn) return;
      var line = e.target.closest('.cart-drawer-line');
      if (!line || changing || line.classList.contains('is-busy')) return;
      var key = line.getAttribute('data-key');
      var qty = 0;
      if (stepBtn) {
        var cur = parseInt(line.querySelector('.cart-drawer-qty-n').textContent, 10) || 0;
        qty = Math.max(0, cur + parseInt(stepBtn.getAttribute('data-step'), 10));
      }
      line.classList.add('is-busy');
      changing = true;
      var seq = ++renderSeq;
      HC.cart.change(key, qty).then(function (cart) {
        changing = false;
        if (seq !== renderSeq) { line.classList.remove('is-busy'); return; } /* stale response; a newer render owns the UI */
        render(cart);
      }).catch(function () {
        changing = false;
        if (seq === renderSeq) errEl.hidden = false;
        line.classList.remove('is-busy');
      });
    });

    /* Product-page add-to-cart: intercept the native /cart/add post so the
       drawer confirms instead of a full navigation to the cart page. The
       cart page's own forms post to /cart (updates[]) and never match.
       No-JS keeps the native post + redirect. */
    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (!form.matches || !form.matches('form[action*="/cart/add"]')) return;
      e.preventDefault();
      var fd = new FormData(form);
      var id = parseInt(fd.get('id'), 10);
      var qty = parseInt(fd.get('quantity'), 10) || 1;
      if (!id) return;
      var btn = form.querySelector('[type="submit"]');
      var label = btn ? btn.firstChild : null;
      var original = label ? label.textContent : '';
      if (btn) { btn.disabled = true; if (label) label.textContent = 'Adding... '; }
      HC.cart.add(id, qty).then(function () {
        if (btn) { btn.disabled = false; if (label) label.textContent = original; }
      }).catch(function () {
        if (label) label.textContent = "Couldn't add - try again ";
        setTimeout(function () {
          if (btn) { btn.disabled = false; if (label) label.textContent = original; }
        }, 2400);
      });
    });
  }

  /* ---------- Nav offset below trust strip ----------
     The trust strip is in-flow (scrolls away) while #topnav is fixed, so at
     scroll 0 a static top-4 puts the pill under the strip's black bar. Track
     the strip's live bottom edge so the pill rides below it, then docks at
     16px once the strip has scrolled off. Elements are re-queried each frame
     so theme-editor section reloads can't strand a stale reference. */
  function updateNavOffset() {
    var nav = document.getElementById('topnav');
    if (!nav) return;
    var strip = document.querySelector('.trust-strip');
    var bottom = strip ? strip.getBoundingClientRect().bottom : 0;
    nav.style.top = Math.max(16, bottom + 12) + 'px';
  }
  function initNavOffset() {
    if (!initNavOffset._bound) {
      initNavOffset._bound = true;
      window.addEventListener('scroll', updateNavOffset, { passive: true });
      window.addEventListener('resize', updateNavOffset);
    }
    updateNavOffset();
  }

  /* ---------- In-page anchor scrolling ----------
     Lenis ignores CSS scroll-margin-top, so same-page hash links must be
     intercepted and given the margin as a scrollTo offset; without this the
     native jump also reads as a teleport instead of the site's smooth glide. */
  function initAnchorScroll() {
    if (initAnchorScroll._bound) return; initAnchorScroll._bound = true;
    document.addEventListener('click', function (e) {
      if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
      var a = e.target.closest ? e.target.closest('a[href*="#"]') : null;
      if (!a || !a.hash || a.hash === '#' || a.hash === '#MainContent') return;
      if (a.host !== location.host || a.pathname !== location.pathname) return;
      var target = null;
      try { target = document.querySelector(a.hash); } catch (err) { return; }
      if (!target) return;
      e.preventDefault();
      if (lenis) {
        var margin = parseFloat(getComputedStyle(target).scrollMarginTop) || 0;
        lenis.scrollTo(target, { offset: -margin });
      } else {
        target.scrollIntoView(); /* respects scroll-margin-top natively */
      }
      if (history.pushState) history.pushState(null, '', a.hash);
    });
  }

  /* ---------- Scroll progress bar ---------- */
  function updateScrollProgress() {
    var bar = document.getElementById('scroll-progress');
    if (!bar) return;
    var h = document.documentElement;
    var max = h.scrollHeight - h.clientHeight;
    var pct = max > 0 ? h.scrollTop / max * 100 : 0;
    bar.style.width = pct + '%';
  }

  function initScrollProgress() {
    if (!document.getElementById('scroll-progress')) return;
    if (!scrollProgressBound) {
      scrollProgressBound = true;
      window.addEventListener('scroll', updateScrollProgress, { passive: true });
    }
    updateScrollProgress();
  }

  /* ---------- Mobile nav drawer ---------- */
  function initNavDrawer() {
    if (navDrawerBound) return;
    var toggle = document.getElementById('nav-toggle');
    var close = document.getElementById('nav-close');
    var drawer = document.getElementById('nav-drawer');
    if (!toggle || !drawer) return;
    navDrawerBound = true;

    function open() {
      drawer.classList.add('is-open');
      drawer.removeAttribute('inert');
      drawer.setAttribute('aria-hidden', 'false');
      toggle.setAttribute('aria-expanded', 'true');
    }
    function shut() {
      drawer.classList.remove('is-open');
      drawer.setAttribute('inert', '');
      drawer.setAttribute('aria-hidden', 'true');
      toggle.setAttribute('aria-expanded', 'false');
    }
    toggle.addEventListener('click', open);
    if (close) close.addEventListener('click', shut);
    drawer.querySelectorAll('[data-nav-link]').forEach(function (link) {
      link.addEventListener('click', shut);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') shut();
    });
  }

  /* ---------- Boot + theme-editor re-init harness ---------- */
  function boot() {
    initMotion();
    initNavOffset();
    initAnchorScroll();
    initScrollProgress();
    initNavDrawer();
    initCartDrawer();
    initPreloader();
    initCursor();
    initMagnetic();
    initMarquee();
    initStickyCta();
    initChapterPill();
    initNavTheme();
    initReviewsLoop();
    initRevealUp();
    initCounters();
    initFaq();
    HC.initAll();
    if (HC.cart) HC.cart.refreshCount();
    if (!prefersReduced && typeof ScrollTrigger !== 'undefined') ScrollTrigger.refresh();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  /* Re-bind chrome and refresh triggers when sections reload in the theme editor.
     Init functions are idempotent (guard flags), so repeated calls won't stack listeners.
     Phase 2 section modules hook the same events to (re)build their own animations. */
  if (inEditor) {
    document.addEventListener('shopify:section:load', function (e) {
      initScrollProgress();
      initNavOffset();
      initNavDrawer();
      var root = e.target.querySelector('[data-hc-section]') || (e.target.getAttribute && e.target.getAttribute('data-hc-section') ? e.target : null);
      HC.initSection(root);
      initRevealUp(e.target);
      initCounters(e.target);
      revealIntroText();
      if (typeof ScrollTrigger !== 'undefined') ScrollTrigger.refresh();
    });
    document.addEventListener('shopify:section:unload', function (e) {
      var root = e.target.querySelector('[data-hc-section]') || e.target;
      HC.teardownSection(root);
      if (typeof ScrollTrigger !== 'undefined') ScrollTrigger.refresh();
    });
    document.addEventListener('shopify:section:select', function () {
      if (typeof ScrollTrigger !== 'undefined') ScrollTrigger.refresh();
    });
  }
})();
